import React from 'react';
import { Nav } from 'react-bootstrap';
import styled from 'styled-components';

type NavBadgeProps = {
    children: JSX.Element;
    size?: TSize;
    className?: string;
};

export type TSize = 'lg' | 'md';

const NavBadge = ({ children, size = 'md', className }: NavBadgeProps) => {
    return (
        <NavBadgeWrapper className={className} size={size}>
            <h3>
                {children}
            </h3>
        </NavBadgeWrapper>
    );
};

const NavBadgeWrapper = styled(Nav.Item)<{ size: TSize }>`
    margin: 0px;
    display: inline-block;

    &:first-child { margin-left: 0; }
    &:last-child .nav-link { margin-right: 0; }

    .nav-link {
        max-width: 180px;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: var(--text_heading_font);
        letter-spacing: var(--text_heading_font_spacing);
        text-transform: var(--text_heading_font_case);
        text-decoration: none;
    }

    ${(props) => (props.theme.v4.navigation_style === 'pill' && `
        h3 {
            display: inline;
            margin: 0;
            padding: 0;
            font-size: 16px;
            line-height: 16px;
        }

        .nav-link {
            padding: 8px 16px;
            border-radius: var(--radius_m);
            text-overflow: ellipsis;
            margin-right: 8px;
            transition: background-color 0.15s ease-in-out;
            border: var(--ui_nav_channels_border);
            border-color: transparent;
            color: var(--ui_nav_channels_pill_inactive_label);

            &:hover, &:focus, &.active {
                border: var(--ui_nav_channels_border);
            }

            &:hover {
                background-color: var(--bg-grey);
            }

            &:focus {
                outline: none;
            }

            &.active {
                background-color: var(--ui_nav_channels);
                color: var(--ui_nav_channels_pill_label);
            }

            &--solo {
                pointer-events: none;
            }
        }
    `)}

    ${(props) => (props.theme.v4.navigation_style === 'underline' && `
        margin-right: 24px;

        .nav-link {
            background-color: transparent;
            border-bottom: var(--ui_nav_channels_underline);
            border-bottom-color: transparent;

            border-radius: 0;
            padding-left: 0;
            padding-right: 0;
            padding-top: 0;
            padding-bottom: 5px;

            line-height: 24px;
            text-align: left;
            transition: border-color 0.2s ease-in-out;

            color: var(--ui_nav_channels_underline_inactive_label);

            &:not(.active):hover {
                border-bottom: var(--ui_nav_channels_underline);
            }

            &.active {
                margin-bottom: 0;
                background-color: transparent;
                border-bottom: var(--ui_nav_channels_underline);
                color: var(--ui_nav_channels_underline_label);
            }
        }
    `)}
`;

export default NavBadge;
